import React, { Component } from 'react';
import {
  Input,
  Checkbox,
  Dropdown,
  Grid,
  Button,
  Container,
  Header
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { countries } from '../../../data/countries.data';
import ClubList from '../../ClubList/ClubList';
import { SyncLoader } from 'react-spinners';
import './AdvancedSearch.css';

export default class AdvancedSearchView extends Component {
  componentWillMount() {
    this.props.requestAdvancedSearchClubs({
      query: { $sort: { numOfFollowers: -1 }, $limit: 24, $skip: 0 }
    });
    this.resetComponent();
  }

  componentWillUpdate(newProps) {
    if (this.state.skip !== newProps.clubs.skip) {
      window.scrollTo(0, 0);
      this.setState({ skip: newProps.clubs.skip });
    }

    if (this.state.total !== newProps.clubs.total) {
      this.setState({
        total: newProps.clubs.total,
        hasNoResults: newProps.clubs.total <= 0
      });
    }
  }

  resetComponent = () => {
    this.setState({
      results: [],
      search: '',
      male: true,
      female: true,
      football: true,
      hurling: true,
      camoige: true,
      country: '',
      skip: 0,
      total: 0,
      limit: 24,
      hasNoResults: false
    });
  };

  handleNextClick = () => {
    this.props.requestAdvancedSearchClubs({
      query: {
        $sort: { numOfFollowers: -1 },
        $limit: 24,
        $skip: this.state.skip + this.state.limit
      }
    });
  };

  handlePrevClick = () => {
    this.props.requestAdvancedSearchClubs({
      query: {
        $sort: { numOfFollowers: -1 },
        $limit: 24,
        $skip: this.state.skip - this.state.limit
      }
    });
  };

  // TODO: Clean up code
  getFilteredClubs = () => {
    var search = { query: { $sort: { numOfFollowers: -1 } } };

    if (this.state.country.length > 0) {
      search.query['country'] = this.state.country;
    }

    if (this.state.male && !this.state.female) {
      search.query['teams.gender'] = 'Male';
    } else if (!this.state.male && this.state.female) {
      search.query['teams.gender'] = 'Female';
    }

    if (this.state.football && !this.state.hurling && !this.state.camoige) {
      search.query['teams.code'] = 'Football';
    } else if (
      this.state.hurling &&
      !this.state.football &&
      !this.state.camoige
    ) {
      search.query['teams.code'] = 'Hurling';
    } else if (
      this.state.camoige &&
      !this.state.hurling &&
      !this.state.football
    ) {
      search.query['teams.code'] = 'Camoige';
    } else if (
      this.state.hurling &&
      this.state.football &&
      !this.state.camoige
    ) {
      search.query['$or'] = [
        { 'teams.code': 'Football' },
        { 'teams.code': 'Hurling' }
      ];
    } else if (
      this.state.hurling &&
      this.state.camoige &&
      !this.state.football
    ) {
      search.query['$or'] = [
        { 'teams.code': 'Camoige' },
        { 'teams.code': 'Hurling' }
      ];
    } else if (
      this.state.camoige &&
      this.state.football &&
      !this.state.hurling
    ) {
      search.query['$or'] = [
        { 'teams.code': 'Camoige' },
        { 'teams.code': 'Football' }
      ];
    }

    if (this.state.search.length > 0) {
      if (!search.query['$or']) {
        search.query['$or'] = [];
      }

      search.query['$or'].push({
        name: { $regex: this.state.search, $options: 'i' }
      });
      search.query['$or'].push({
        city: { $regex: this.state.search, $options: 'i' }
      });
      search.query['$or'].push({
        state: { $regex: this.state.search, $options: 'i' }
      });
      search.query['$or'].push({
        country: { $regex: this.state.search, $options: 'i' }
      });
    }

    this.props.requestAdvancedSearchClubs(search);
  };

  // TODO: Clean up code
  handleChange = (e, { name, value }) => {
    // TODO: Create enums
    switch (name) {
      case 'male':
      case 'female':
      case 'football':
      case 'hurling':
      case 'camoige':
        this.setState({ [name]: !this.state[name] }, () =>
          this.getFilteredClubs()
        );
        break;
      case 'country':
        this.setState({ country: value }, () => this.getFilteredClubs());
        break;
      default:
        this.setState({ [name]: value }, () => this.getFilteredClubs());
    }
  };

  render() {
    return (
      <Grid divided="vertically" className="advanced-search" stackable={true}>
        <Grid.Row columns={2}>
          <Grid.Column width={5}>
            <div className="form-row">
              <h4>Search</h4>
              <Input
                placeholder="Search by name, city, country"
                fluid
                onChange={this.handleChange}
                name="search"
              />
            </div>
            <div className="form-row">
              <h4>Country</h4>
              <Dropdown
                placeholder="Select country"
                search
                selection
                options={countries}
                onChange={this.handleChange}
                name="country"
                fluid
              />
            </div>
            <div className="form-row row-sm-half-width">
              <h4>Gender</h4>
              <Checkbox
                label="Male"
                onChange={this.handleChange}
                name="male"
                defaultChecked
                toggle
              />{' '}
              <br />
              <Checkbox
                label="Female"
                onChange={this.handleChange}
                name="female"
                defaultChecked
                toggle
              />
            </div>
            <div className="form-row row-sm-half-width">
              <h4>Sport</h4>
              <Checkbox
                label="Football"
                onChange={this.handleChange}
                name="football"
                defaultChecked
                toggle
              />{' '}
              <br />
              <Checkbox
                label="Hurling"
                onChange={this.handleChange}
                name="hurling"
                defaultChecked
                toggle
              />{' '}
              <br />
              <Checkbox
                label="Camoige"
                onChange={this.handleChange}
                name="camoige"
                defaultChecked
                toggle
              />
            </div>
          </Grid.Column>
          <Grid.Column width={11}>
            {this.props.clubs &&
            this.props.clubs.data &&
            this.props.clubs.data.length > 0 ? (
              <div>
                <div className="advanced-search__pagination-info">
                  Showing
                  {this.props.clubs.skip <= 0
                    ? ` 1 to ${this.props.clubs.data.length}`
                    : ` ${this.props.clubs.skip + 1} to ${this.props.clubs
                        .skip + this.props.clubs.data.length}`}{' '}
                  of {this.props.clubs.total} Clubs
                </div>
                <ClubList
                  clubs={this.props.clubs.data}
                  row="3"
                  history={this.props.history}
                />
                <div className="pagination">
                  <Button
                    content="Prev"
                    icon="left arrow"
                    labelPosition="left"
                    color="blue"
                    disabled={this.state.skip <= 0}
                    onClick={this.handlePrevClick}
                  />
                  <Button
                    content="Next"
                    icon="right arrow"
                    labelPosition="right"
                    floated="right"
                    color="blue"
                    disabled={
                      this.state.skip + this.state.limit >= this.state.total
                    }
                    onClick={this.handleNextClick}
                  />
                </div>
              </div>
            ) : (
              <div className="spinner__container">
                {this.state.hasNoResults ? (
                  <Container text>
                    <Header as="h2">No clubs found.</Header>
                  </Container>
                ) : (
                  <SyncLoader loading={true} margin="7px" color="#007849" />
                )}
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

AdvancedSearchView.defaultProps = {
  requestSearchClubs: () => ({}),
  clubs: []
};

AdvancedSearchView.propTypes = {
  advancedSearchClubs: PropTypes.func,
  // clubs: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     _id: PropTypes.string.isRequired,
  //     name: PropTypes.string.isRequired,
  //     city: PropTypes.string.isRequired,
  //     state: PropTypes.string.isRequired,
  //     country: PropTypes.string.isRequired
  //   })
  // ),
  history: PropTypes.shape({
    push: PropTypes.func
  })
};



// WEBPACK FOOTER //
// ./src/components/Search/Advanced/AdvancedSearchView.js